import { Link, useHistory } from "react-router-dom";
import { setValToLS } from "../helpers";

const Nav = ({ on, user }) => {
	const history = useHistory();

	const handleSignout = () => {
		setValToLS("dash", null, true);
		history.push("/");
	};

	return (
		<>
			{user && (
				<div className="steps" style={{ paddingBottom: "5px" }}>
					{user.organization && <h3>{user.organization}</h3>}

					<h4>{`Welcome, ${user.fname}`}</h4>

					<button
						type="button"
						className="btn-alt"
						onClick={() => handleSignout()}
					>
						Sign Out
					</button>

					<ol>
						{[
							{
								id: 1,
								name: "BFC Dashboard Home",
								link: "/dashboard",
							},
							{
								id: 2,
								name: "Add / Invite Guests",
								link: "/dashboard/invite",
							},
							{
								id: 3,
								name: "View All Guests",
								link: "/dashboard/statuses",
							},
							{
								id: 4,
								name: "View Invoice",
								link: "/dashboard/invoice",
							},
							{
								id: 5,
								name: "Update Contact Info",
								link: "/dashboard/contact",
							},
							{
								id: 6,
								name: "Add Dashboard Users",
								link: "/dashboard/users",
							},
							{
								id: 7,
								name: "Digital Asset Contact",
								link: "/dashboard/asset",
							},
							{
								id: 8,
								name: "Upload Logo & Assets",
								link: "/dashboard/upload",
							},
							{
								id: 9,
								name: "Manage Hotel Occupants",
								link: "/dashboard/hotel",
							},
						].map((item) => {
							return (
								<li className={item.id === on ? "selected" : ""} key={item.id}>
									<Link to={item.link}>{item.name}</Link>
								</li>
							);
						})}
					</ol>
				</div>
			)}

			{on === 4 ? (
				<div className="blocktext" style={{ marginTop: "20px" }}>
					Questions? Please contact Diana Rendon at (210) 345-7877 or email{" "}
					<a href={`mailto:diana@valerotexasopen.com`}>
						diana@valerotexasopen.com
					</a>
					.
				</div>
			) : (
				<div className="blocktext" style={{ marginTop: "20px" }}>
					Questions? Please contact {user.liaison.text} or email{" "}
					<a href={`mailto:${user.liaison.email}`}>{user.liaison.email}</a>.
				</div>
			)}
		</>
	);
};

export default Nav;
